import { Component, computed, input } from '@angular/core';

export type WHButtonGroupAlign = 'start' | 'end' | 'center' | 'space-between';

@Component({
  selector: 'w-h-button-group',
  standalone: true,
  template: `
    <div [class]="alignmentClass()" [style.gap.px]="gap()">
      <ng-content select="w-h-button" />
    </div>
  `,
  styles: `
    :host {
      display: block;
    }
  `,
})
export class WHButtonGroupComponent {
  /** Flex alignment for buttons */
  readonly align = input<WHButtonGroupAlign>('end');

  /** Gap between buttons in pixels */
  readonly gap = input<number>(8);

  protected readonly alignmentClass = computed(() => {
    switch (this.align()) {
      case 'start':
        return 'flex--r-c flex-wrapper';
      case 'center':
        return 'flex--r-c-c flex-wrapper';
      case 'space-between':
        return 'flex--r-c-sb flex-wrapper';
      case 'end':
      default:
        return 'flex--r-c-fe flex-wrapper';
    }
  });
}
